import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AvailableBookingHours = {
  contactType: ContactMethod;
  lawyers: Array<Maybe<Lawyer>>;
  legalOffices: Array<Maybe<LegalOffice>>;
};

export type AvailableBookingTimeSlot = {
  booked: Scalars["Boolean"];
  contactType: ContactMethod;
  lawyer: Lawyer;
  legalOffice?: Maybe<LegalOffice>;
  timeSlot: TimeSlot;
};

export type ClientReservation = {
  /** The Lawyer assigned to the reservation */
  assignedLawyer: Lawyer;
  /** The chosen contactMethod */
  chosenContactMethod: ContactMethod;
  /** The chosen specialty of reservation */
  chosenSpecialty: Specialty;
  /** The ID of the client */
  clientId: Scalars["ID"];
  /** Client name */
  clientName?: Maybe<Scalars["String"]>;
  /** A client type to indicate if client is an individual or a company */
  clientType?: Maybe<Scalars["String"]>;
  /** Client's phone number */
  phoneNumber?: Maybe<Scalars["String"]>;
  /** The ID of the reservation */
  reservationId: Scalars["ID"];
  /** Any message to the lawyer given by the client at reservation time */
  reservationMessage?: Maybe<Scalars["String"]>;
  /** Reservation time as a UTC timestamp */
  reservationTime?: Maybe<Scalars["String"]>;
  /** A user type to indicate a guest user, registered user, or maybe subscribed */
  userType?: Maybe<Scalars["String"]>;
  /** Client's whatsapp number */
  whatsappNumber?: Maybe<Scalars["String"]>;
};

export type ContactMethod = {
  ar: ContactMethodAttributes;
  description?: Maybe<Scalars["String"]>;
  id: ContactMethodName;
  name: Scalars["String"];
};

export type ContactMethodAttributes = {
  description?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export enum ContactMethodName {
  InPerson = "IN_PERSON",
  OnlineMeeting = "ONLINE_MEETING",
  PhoneCall = "PHONE_CALL",
}

export type Lawyer = {
  /** Lawyer details in Arabic */
  ar: LawyerAttributes;
  /** The times slots that the lawyer indicated they are working */
  bookingTimeSlots?: Maybe<Array<Maybe<LawyerBookingTimeSlot>>>;
  /** Lawyer details in English */
  en: LawyerAttributes;
  /** Lawyer system ID */
  id: Scalars["ID"];
  /** The legal services the lawyer specializes in */
  specialties: Array<Specialty>;
  /** The days and times worked */
  workingHours: WorkingDays;
};

export type LawyerAttributes = {
  name: Scalars["String"];
};

export type LawyerBookingTimeSlot = {
  booked: Scalars["Boolean"];
  clientReservation?: Maybe<ClientReservation>;
  contactType: ContactMethod;
  timeSlot: TimeSlot;
};

export type LegalOffice = {
  /** Legal office details in Arabic */
  ar: LawyerAttributes;
  /** The times slots that the legal office indicated they are working */
  bookingTimeSlots?: Maybe<Array<Maybe<LawyerBookingTimeSlot>>>;
  /** Legal office details in English */
  en: LawyerAttributes;
  /** The legal office lead lawyers */
  headLawyers: Array<Lawyer>;
  id: Scalars["ID"];
  /** The list of lawyers working in the legal office */
  lawyers: Array<Lawyer>;
  /** The legal services the legal office specializes in */
  specialties: Array<Specialty>;
  /** The days and times worked */
  workingHours: WorkingDays;
};

export type Mutation = {
  newClientReservation?: Maybe<NewClientReservationResponse>;
};

export type MutationNewClientReservationArgs = {
  lawyerId: Scalars["ID"];
  reservation: NewClientReservationInput;
};

export type NewClientReservationInput = {
  /** The ID of the client */
  clientId: Scalars["ID"];
  /** A client type to indicate if client is an individual or a company */
  clientType?: InputMaybe<Scalars["String"]>;
  /** Client name */
  name?: InputMaybe<Scalars["String"]>;
  /** Client's phone number */
  phoneNumber?: InputMaybe<Scalars["String"]>;
  /** The ID of the reservation */
  reservationId: Scalars["ID"];
  /** Any message to the lawyer given by the client at reservation time */
  reservationMessage?: InputMaybe<Scalars["String"]>;
  /** A user type to indicate a guest user, registered user, or maybe subscribed */
  userType?: InputMaybe<Scalars["String"]>;
  /** Client's whatsapp number */
  whatsappNumber?: InputMaybe<Scalars["String"]>;
};

export type NewClientReservationResponse = {
  code: Scalars["Int"];
  message: Scalars["String"];
  reservation?: Maybe<ClientReservation>;
  success: Scalars["Boolean"];
};

export type Query = {
  /** Get available supported contact methods */
  availableContactMethods: Array<ContactMethod>;
  /** Get available booking time slots from all lawyers */
  availableTimes?: Maybe<Array<AvailableBookingTimeSlot>>;
  /** Get available booking time slots from all lawyers */
  availableTimesByDay?: Maybe<Array<AvailableBookingHours>>;
  /** Get tracks array for homepage grid */
  specialtiesForHome: Array<Specialty>;
};

export type QueryAvailableTimesByDayArgs = {
  day?: InputMaybe<WeekDay>;
};

/** A specialty is a legal specialization */
export type Specialty = {
  /** Specialty Attributes in Arabic */
  ar: SpecialtyAttributes;
  /** Specialty Attributes in English */
  en: SpecialtyAttributes;
  id: Scalars["ID"];
  /** The list of lawyers who provide this kind of specialty */
  lawyers: Array<Maybe<Lawyer>>;
  /** The list of lawyers who provide this kind of specialty */
  legalOffices: Array<Maybe<LegalOffice>>;
};

export type SpecialtyAttributes = {
  /** The description of the specialty */
  description?: Maybe<Scalars["String"]>;
  /** The name of the specialty */
  title: Scalars["String"];
};

export type TimeSlot = {
  /** The reservation time in UTC */
  utcDate: Scalars["String"];
};

export enum WeekDay {
  Friday = "friday",
  Monday = "monday",
  Saturday = "saturday",
  Sunday = "sunday",
  Thursday = "thursday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
}

export type WeekDayInput = {
  day?: InputMaybe<WeekDay>;
};

export type WorkingDays = {
  friday?: Maybe<WorkingHours>;
  monday?: Maybe<WorkingHours>;
  saturday?: Maybe<WorkingHours>;
  sunday?: Maybe<WorkingHours>;
  thursday?: Maybe<WorkingHours>;
  tuesday?: Maybe<WorkingHours>;
  wednesday?: Maybe<WorkingHours>;
};

export type WorkingHours = {
  /** The starting UTC hour as a number between 0-23 */
  workHoursFrom: Scalars["Int"];
  /** The ending UTC hour as a number between 0-23 */
  workHoursTo: Scalars["Int"];
};

export type AvailableTimesByDayQueryVariables = Exact<{
  day?: InputMaybe<WeekDay>;
}>;

export type AvailableTimesByDayQuery = {
  availableTimesByDay?: Array<{
    lawyers: Array<{
      id: string;
      en: { name: string };
      ar: { name: string };
      specialties: Array<{
        ar: { title: string; description?: string | null };
        en: { title: string; description?: string | null };
      }>;
      workingHours: {
        monday?: { workHoursFrom: number; workHoursTo: number } | null;
        tuesday?: { workHoursFrom: number; workHoursTo: number } | null;
        wednesday?: { workHoursFrom: number; workHoursTo: number } | null;
        thursday?: { workHoursFrom: number; workHoursTo: number } | null;
        friday?: { workHoursFrom: number; workHoursTo: number } | null;
        saturday?: { workHoursFrom: number; workHoursTo: number } | null;
        sunday?: { workHoursFrom: number; workHoursTo: number } | null;
      };
    } | null>;
    legalOffices: Array<{
      id: string;
      en: { name: string };
      ar: { name: string };
      specialties: Array<{
        ar: { title: string; description?: string | null };
        en: { title: string; description?: string | null };
      }>;
      headLawyers: Array<{ en: { name: string } }>;
      workingHours: {
        monday?: { workHoursFrom: number; workHoursTo: number } | null;
        tuesday?: { workHoursFrom: number; workHoursTo: number } | null;
        wednesday?: { workHoursFrom: number; workHoursTo: number } | null;
        thursday?: { workHoursFrom: number; workHoursTo: number } | null;
        friday?: { workHoursFrom: number; workHoursTo: number } | null;
        saturday?: { workHoursFrom: number; workHoursTo: number } | null;
        sunday?: { workHoursFrom: number; workHoursTo: number } | null;
      };
    } | null>;
    contactType: { name: string };
  }> | null;
};

export type GetBookingTimesQueryVariables = Exact<{ [key: string]: never }>;

export type GetBookingTimesQuery = {
  availableTimes?: Array<{
    booked: boolean;
    timeSlot: { utcDate: string };
    contactType: { name: string };
    lawyer: {
      id: string;
      en: { name: string };
      ar: { name: string };
      specialties: Array<{
        ar: { title: string; description?: string | null };
        en: { title: string; description?: string | null };
      }>;
    };
  }> | null;
};

export type AvailableContactMethodsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableContactMethodsQuery = {
  availableContactMethods: Array<{
    id: ContactMethodName;
    name: string;
    description?: string | null;
    ar: { name: string; description?: string | null };
  }>;
};

export type GetSpecialtiesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSpecialtiesQuery = {
  specialtiesForHome: Array<{
    en: { title: string; description?: string | null };
    ar: { title: string; description?: string | null };
  }>;
};

export const AvailableTimesByDayDocument = gql`
  query AvailableTimesByDay($day: WeekDay) {
    availableTimesByDay(day: $day) {
      lawyers {
        id
        en {
          name
        }
        ar {
          name
        }
        specialties {
          ar {
            title
            description
          }
          en {
            title
            description
          }
        }
        workingHours {
          monday {
            workHoursFrom
            workHoursTo
          }
          tuesday {
            workHoursFrom
            workHoursTo
          }
          wednesday {
            workHoursFrom
            workHoursTo
          }
          thursday {
            workHoursFrom
            workHoursTo
          }
          friday {
            workHoursFrom
            workHoursTo
          }
          saturday {
            workHoursFrom
            workHoursTo
          }
          sunday {
            workHoursFrom
            workHoursTo
          }
        }
      }
      legalOffices {
        id
        en {
          name
        }
        ar {
          name
        }
        specialties {
          ar {
            title
            description
          }
          en {
            title
            description
          }
        }
        headLawyers {
          en {
            name
          }
        }
        workingHours {
          monday {
            workHoursFrom
            workHoursTo
          }
          tuesday {
            workHoursFrom
            workHoursTo
          }
          wednesday {
            workHoursFrom
            workHoursTo
          }
          thursday {
            workHoursFrom
            workHoursTo
          }
          friday {
            workHoursFrom
            workHoursTo
          }
          saturday {
            workHoursFrom
            workHoursTo
          }
          sunday {
            workHoursFrom
            workHoursTo
          }
        }
      }
      contactType {
        name
      }
    }
  }
`;

/**
 * __useAvailableTimesByDayQuery__
 *
 * To run a query within a React component, call `useAvailableTimesByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTimesByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTimesByDayQuery({
 *   variables: {
 *      day: // value for 'day'
 *   },
 * });
 */
export function useAvailableTimesByDayQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableTimesByDayQuery,
    AvailableTimesByDayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AvailableTimesByDayQuery,
    AvailableTimesByDayQueryVariables
  >(AvailableTimesByDayDocument, options);
}
export function useAvailableTimesByDayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableTimesByDayQuery,
    AvailableTimesByDayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableTimesByDayQuery,
    AvailableTimesByDayQueryVariables
  >(AvailableTimesByDayDocument, options);
}
export type AvailableTimesByDayQueryHookResult = ReturnType<
  typeof useAvailableTimesByDayQuery
>;
export type AvailableTimesByDayLazyQueryHookResult = ReturnType<
  typeof useAvailableTimesByDayLazyQuery
>;
export type AvailableTimesByDayQueryResult = Apollo.QueryResult<
  AvailableTimesByDayQuery,
  AvailableTimesByDayQueryVariables
>;
export const GetBookingTimesDocument = gql`
  query getBookingTimes {
    availableTimes {
      timeSlot {
        utcDate
      }
      booked
      contactType {
        name
      }
      lawyer {
        id
        en {
          name
        }
        ar {
          name
        }
        specialties {
          ar {
            title
            description
          }
          en {
            title
            description
          }
        }
      }
    }
  }
`;

/**
 * __useGetBookingTimesQuery__
 *
 * To run a query within a React component, call `useGetBookingTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingTimesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingTimesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBookingTimesQuery,
    GetBookingTimesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBookingTimesQuery, GetBookingTimesQueryVariables>(
    GetBookingTimesDocument,
    options
  );
}
export function useGetBookingTimesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingTimesQuery,
    GetBookingTimesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingTimesQuery,
    GetBookingTimesQueryVariables
  >(GetBookingTimesDocument, options);
}
export type GetBookingTimesQueryHookResult = ReturnType<
  typeof useGetBookingTimesQuery
>;
export type GetBookingTimesLazyQueryHookResult = ReturnType<
  typeof useGetBookingTimesLazyQuery
>;
export type GetBookingTimesQueryResult = Apollo.QueryResult<
  GetBookingTimesQuery,
  GetBookingTimesQueryVariables
>;
export const AvailableContactMethodsDocument = gql`
  query AvailableContactMethods {
    availableContactMethods {
      id
      name
      description
      ar {
        name
        description
      }
    }
  }
`;

/**
 * __useAvailableContactMethodsQuery__
 *
 * To run a query within a React component, call `useAvailableContactMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableContactMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableContactMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableContactMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableContactMethodsQuery,
    AvailableContactMethodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AvailableContactMethodsQuery,
    AvailableContactMethodsQueryVariables
  >(AvailableContactMethodsDocument, options);
}
export function useAvailableContactMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableContactMethodsQuery,
    AvailableContactMethodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableContactMethodsQuery,
    AvailableContactMethodsQueryVariables
  >(AvailableContactMethodsDocument, options);
}
export type AvailableContactMethodsQueryHookResult = ReturnType<
  typeof useAvailableContactMethodsQuery
>;
export type AvailableContactMethodsLazyQueryHookResult = ReturnType<
  typeof useAvailableContactMethodsLazyQuery
>;
export type AvailableContactMethodsQueryResult = Apollo.QueryResult<
  AvailableContactMethodsQuery,
  AvailableContactMethodsQueryVariables
>;
export const GetSpecialtiesDocument = gql`
  query getSpecialties {
    specialtiesForHome {
      en {
        title
        description
      }
      ar {
        title
        description
      }
    }
  }
`;

/**
 * __useGetSpecialtiesQuery__
 *
 * To run a query within a React component, call `useGetSpecialtiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialtiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialtiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpecialtiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSpecialtiesQuery,
    GetSpecialtiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSpecialtiesQuery, GetSpecialtiesQueryVariables>(
    GetSpecialtiesDocument,
    options
  );
}
export function useGetSpecialtiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSpecialtiesQuery,
    GetSpecialtiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSpecialtiesQuery, GetSpecialtiesQueryVariables>(
    GetSpecialtiesDocument,
    options
  );
}
export type GetSpecialtiesQueryHookResult = ReturnType<
  typeof useGetSpecialtiesQuery
>;
export type GetSpecialtiesLazyQueryHookResult = ReturnType<
  typeof useGetSpecialtiesLazyQuery
>;
export type GetSpecialtiesQueryResult = Apollo.QueryResult<
  GetSpecialtiesQuery,
  GetSpecialtiesQueryVariables
>;
